import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosInstance, { fronturl } from '../../../axiosInstance'; import { Link, useNavigate, useParams } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';
import toast from 'react-hot-toast';
import Gallery from '../../components/Gallery';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill styles
import Select from 'react-select';
import { triggerChooseimg } from '../../components/ChooseImg';
import jsPDF from 'jspdf';

import html2canvas from 'html2canvas';
import getDecryptData from '../../../helpers/getDecryptData';
import { useThemeContext } from '../../../fetchdata/ThemeContext';
import LoadingScreen from '../../components/LoadingScreen';

const MAPKEY = 'AIzaSyBHphidysElJ48mG4AAroD5e7pIJ57XCFg';

const carTypeOptions = [
  'Manual',
  'Automatic',
  'EV',
  'Commercial Heavy',
];

const FullOrderView = () => {
 
  const { sendMessage } = useThemeContext();

       const mydata = getDecryptData();
        const mydatatype = mydata?.type || null;
        const mydatatypeEmp = mydata?.empType || null;
 
  const [Order, setOrder] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [OrderPlace, setOrderPlace] = useState('');
  const [MYuser, setMYuser] = useState('');

  const { userId, id } = useParams();

  const [data, setData] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state
  const [pickupSuggestions, setPickupSuggestions] = useState([]);
  const [dropoffSuggestions, setDropoffSuggestions] = useState([]);
 
  const navigate = useNavigate();

  const ensureGoogleMaps = () => {
    return new Promise((resolve, reject) => {
      if (window.google?.maps?.places) {
        resolve();
        return;
      }

      const scriptId = 'google-maps-script';
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        existingScript.addEventListener('load', resolve, { once: true });
        existingScript.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.id = scriptId;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${MAPKEY}&libraries=places`;
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });
  };

  const getPlaceSuggestions = async (value, setter) => {
    setter([]);
    if (!value.trim()) return;

    try {
      await ensureGoogleMaps();
      const autoService = new window.google.maps.places.AutocompleteService();
      autoService.getPlacePredictions({ input: value }, (predictions) => {
        if (!predictions?.length) {
          setter([]);
          return;
        }

        const placesService = new window.google.maps.places.PlacesService(document.createElement('div'));
        Promise.all(predictions.map((prediction) => new Promise((resolve) => {
          placesService.getDetails(
            { placeId: prediction.place_id, fields: ['geometry', 'formatted_address', 'name'] },
            (place, status) => {
              if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                resolve({
                  ...prediction,
                  address: place.formatted_address || prediction.description,
                  lat: place.geometry.location.lat(),
                  lng: place.geometry.location.lng(),
                });
              } else {
                resolve(null);
              }
            }
          );
        }))).then((results) => setter(results.filter(Boolean)));
      });
    } catch (error) {
      toast.error('Google map search failed');
    }
  };

  const saveAsPDF = async () => {
    const printContent = document.getElementById('print');

    // Set the scale factor for better quality
    const scale = 5;

    // Set the quality of the JPEG image
    const imageQuality = 1; // 1 is maximum quality

    // Convert print content to image with higher scale
    html2canvas(printContent, {
      scale: scale,
      useCORS: true, // Enable CORS to support loading images from different origins
      logging: true // Enable logging for debugging
    }).then(canvas => {
      const imgData = canvas.toDataURL('image/jpeg', imageQuality); // Use JPEG format with specified quality

      // Calculate dimensions of PDF page
      const pdfWidth = 297; // A4 width in mm
      const pdfHeight = 210; // A4 height in mm
      const ratio = canvas.width / canvas.height;

      let pdfHeightAdjusted = pdfHeight;
      let pdfWidthAdjusted = pdfWidth;

      if (ratio < pdfWidth / pdfHeight) {
        pdfWidthAdjusted = pdfHeight * ratio;
      } else {
        pdfHeightAdjusted = pdfWidth / ratio;
      }

      // Create a new jsPDF instance
      const pdf = new jsPDF({
        orientation: 'landscape', // Set the orientation of the PDF to landscape
        unit: 'mm', // Use millimeters as the unit for measurements
        format: [pdfWidth, pdfHeight] // Set the format of the PDF (A4 size)
      });

      // Add image to PDF document
      pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidthAdjusted, pdfHeightAdjusted);

      // Save the PDF
      pdf.save("invoice.pdf");
    });
  }

  const fetchData = async () => {
    setLoading(true);
    console.log("response.data start");

    try {
      const response = await axiosInstance.get("/get-all-zones");
      console.log("response.data.Zones,", response.data.Zones);
      setData(response.data.Zones);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

    const [items, setItems] = useState([]);

    const numberItemFields = [
      "quantity",
      "price",
      "salePrice",
      "gst",
      "GSTPrice",
      "minPrice",
      "kmCharges",
      "day",
      "fullday",
      "logic",
      "hour",
      "NightCharges",
    ];

    const toNumber = (value) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    };

    const chargeFields = [
      "bookingCharges",
      "nightCharges",
      "mealCharges",
      "conveyanceCharges",
    ];

    const getOrderChargeValue = (orderData = Order, field) => {
      if (field === "nightCharges") {
        return toNumber(orderData?.nightCharges ?? orderData?.items?.[0]?.NightCharges);
      }

      if (field === "mealCharges") {
        return toNumber(orderData?.mealCharges ?? orderData?.foodCharges);
      }

      return toNumber(orderData?.[field]);
    };

    const calculateNightChargeTotal = (orderData = Order) =>
      getOrderChargeValue(orderData, "nightCharges") * toNumber(orderData?.nightDays);

    const formatOrderAmount = (value) => {
      const amount = toNumber(value);
      return Number.isInteger(amount) ? String(amount) : amount.toFixed(2);
    };

    const calculateChargesTotal = (orderData = Order) =>
      chargeFields.reduce(
        (total, field) =>
          total +
          (field === "nightCharges"
            ? calculateNightChargeTotal(orderData)
            : getOrderChargeValue(orderData, field)),
        0
      );

    const calculateOrderTaxAmount = (orderData = Order) => {
      const savedGst = toNumber(orderData?.driverCommissionGST);
      if (savedGst > 0) return savedGst;

      const savedCommission = toNumber(orderData?.driverCommissionAmount);
      if (savedCommission > 0) {
        return savedCommission - savedCommission / 1.18;
      }

      const percent = toNumber(orderData?.driverCommissionPercent);
      if (!percent) return 0;

      const subtotal = calculateItemsSubtotal(orderData.items || []);
      const commissionBase = Math.max(
        0,
        subtotal -
          getOrderChargeValue(orderData, "mealCharges") -
          getOrderChargeValue(orderData, "conveyanceCharges") +
          toNumber(orderData?.discount)
      );
      return (commissionBase * percent * 18) / 10000;
    };

    const calculateItemsSubtotal = (orderItems = []) =>
      orderItems.reduce((total, item) => {
        const quantity = toNumber(item.quantity) || 1;
        return total + quantity * toNumber(item.price);
      }, 0);

    const calculateOrderTotal = (orderData = {}, forceIncludeCharges = false) =>
      {
        const itemsSubtotal = calculateItemsSubtotal(orderData.items || []);
        const discountAmount = Math.abs(toNumber(orderData.discount));
        const savedTotal = Number(orderData.totalAmount);

        if (
          !forceIncludeCharges &&
          Number.isFinite(savedTotal) &&
          Math.round(Math.max(0, itemsSubtotal - discountAmount)) === Math.round(Math.max(0, savedTotal))
        ) {
          return Math.max(0, savedTotal);
        }

        return Math.max(
          0,
          itemsSubtotal +
            calculateChargesTotal(orderData) -
            discountAmount +
            calculateOrderTaxAmount(orderData)
        );
      };

    const handleItemChange = (index, field, value) => {
      const updatedItems = [...(Order.items || [])];
      const nextValue = numberItemFields.includes(field) ? toNumber(value) : value;

      updatedItems[index] = {
        ...updatedItems[index],
        [field]: nextValue,
      };

      if (field === "day") {
        updatedItems[index].fullday = nextValue;
      }

      if (field === "fullday") {
        updatedItems[index].day = nextValue;
      }

      if (field === "price") {
        updatedItems[index].GSTPrice = nextValue;
      }

      setOrder(prev => ({
        ...prev,
        items: updatedItems,
        totalAmount: calculateOrderTotal({ ...prev, items: updatedItems }),
      }));
    };

    const handleDiscountChange = (value) => {
      const discount = toNumber(value);
      setOrder((prev) => ({
        ...prev,
        discount,
        totalAmount: calculateOrderTotal({ ...prev, discount }),
      }));
    };

    const handleChargeChange = (field, value) => {
      const charge = toNumber(value);
      const chargeUpdate =
        field === "mealCharges"
          ? { mealCharges: charge, foodCharges: charge }
          : { [field]: charge };

      setOrder((prev) => ({
        ...prev,
        ...chargeUpdate,
        totalAmount: calculateOrderTotal({ ...prev, ...chargeUpdate }, true),
      }));
    };

    const handleItemLocationChange = (index, field, value) => {
      const updatedItems = [...(Order.items || [])];
      updatedItems[index] = {
        ...updatedItems[index],
        [field]: value,
      };

      setOrder((prev) => ({
        ...prev,
        items: updatedItems,
        location: field === 'pickup' && index === 0 ? value : prev.location,
      }));

      getPlaceSuggestions(value, field === 'pickup' ? setPickupSuggestions : setDropoffSuggestions);
    };

    const handlePickupFullAddressChange = (value) => {
      const updatedItems = [...(Order.items || [])];
      if (!updatedItems[0]) return;

      updatedItems[0] = {
        ...updatedItems[0],
        pickupFullAddress: value,
      };

      setOrder((prev) => ({
        ...prev,
        pickupFullAddress: value,
        items: updatedItems,
      }));
    };

    const handleItemLocationMetaChange = (index, field, key, value) => {
      const metaField = field === 'pickup' ? 'pickupMeta' : 'dropoffMeta';
      const updatedItems = [...(Order.items || [])];
      updatedItems[index] = {
        ...updatedItems[index],
        [metaField]: {
          ...(updatedItems[index]?.[metaField] || {}),
          [key]: value,
        },
      };

      setOrder((prev) => ({
        ...prev,
        items: updatedItems,
        latitude: field === 'pickup' && index === 0 && key === 'lat' ? value : prev.latitude,
        longitude: field === 'pickup' && index === 0 && key === 'lng' ? value : prev.longitude,
      }));
    };

    const selectItemLocation = (index, field, result) => {
      const metaField = field === 'pickup' ? 'pickupMeta' : 'dropoffMeta';
      const value = result.description || result.address || '';
      const updatedItems = [...(Order.items || [])];
      updatedItems[index] = {
        ...updatedItems[index],
        [field]: value,
        [metaField]: {
          lat: result.lat,
          lng: result.lng,
        },
      };

      setOrder((prev) => ({
        ...prev,
        items: updatedItems,
        location: field === 'pickup' && index === 0 ? value : prev.location,
        latitude: field === 'pickup' && index === 0 ? result.lat : prev.latitude,
        longitude: field === 'pickup' && index === 0 ? result.lng : prev.longitude,
      }));

      if (field === 'pickup') {
        setPickupSuggestions([]);
      } else {
        setDropoffSuggestions([]);
      }
    };


    const handleChange = (index, field, value) => {
    const updatedItems = [...items];
    updatedItems[index][field] = field === 'title' ? value : Number(value);
    setItems(updatedItems);
  };

const handleAddRow = () => {
  setOrder((prevData) => ({
    ...prevData,
    items: [
      ...prevData.items,
      {
        title: '',
        quantity: 1,
        price: 0,
        salePrice: 0,
        minPrice: 0,
        kmCharges: 0,
        day: 0,
        fullday: 0,
        logic: 0,
        gst: 0,
        isNew: true  // ✅ flag to identify new row
      }
    ]
  }));

setItems((prevData) => [
  ...prevData,
  {
    title: '',
    quantity: 1,
    price: 0,
    gst: 0,
   }
]);


}



  const getUserOrders = async () => {
    setIsLoading(true);
    try {
      // const id = localStorage.getItem('userId');
      const { data } = await axiosInstance.get(`/user-orders-view/${id}`);

      if (data?.success) {
        console.log('order', data)
        const userOrder = data?.userOrder || {};
        const normalizedOrder = {
          ...userOrder,
          bookingCharges: toNumber(userOrder.bookingCharges),
          nightCharges: getOrderChargeValue(userOrder, "nightCharges"),
          mealCharges: getOrderChargeValue(userOrder, "mealCharges"),
          foodCharges: getOrderChargeValue(userOrder, "mealCharges"),
          conveyanceCharges: toNumber(userOrder.conveyanceCharges),
          discount: toNumber(userOrder.discount),
        };
        normalizedOrder.totalAmount = Math.max(0, toNumber(userOrder.totalAmount));
        setOrder(normalizedOrder);
       getUserAllPro(data?.userOrder?.items[0]?.id);
      }
      setIsLoading(false); // Set loading state to false after fetching data

    } catch (error) {
      console.log(error);
      setIsLoading(false); // Set loading state to false in case of an error
      toast.error("order Not found");
      navigate('/all-order');
    }
  };

  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);


  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  }

  function formatDateTime(dateString) {
    if (!dateString) return 'NA';
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return 'NA';
    return date.toLocaleString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  }




        const [searchQuery, setSearchQuery] = useState("");
          const [showSearch, setShowSearch] = useState("false");


          const handleInputChange = (e) => {
            setSearchQuery(e.target.value);
          };


          const handleClearClick = () => {
            setSearchQuery("");
          };


    const [AllProducts, setAllProducts] = useState([]);
            const [ProductId, setProductId] = useState({});

              const filteredProducts = AllProducts.filter((item) =>
    item.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

            const getUserAllPro = async (pro) => {
              
              try {
                 
                  const response = await axiosInstance.get(`/all-products?pro=${pro || ''}`);
          
                  setAllProducts(response.data.products);
                  console.log('setAllProducts', response.data.products)
          
              } catch (error) {
                  console.error('Error fetching user products:', error);
              } 
          };

        const handleClickProduct = (product) => {

            setOrder((prevData) => ({
    ...prevData,
    items: [
      ...prevData.items,
      { 
        id: product._id,
        title: product.title,
        quantity: 1,
        price: product.salePrice,
        salePrice: product.salePrice,
        minPrice: product.minPrice || 0,
        kmCharges: product.kmCharges || 0,
        day: product.day || product.fullday || 0,
        fullday: product.fullday || product.day || 0,
        logic: product.logic || 0,
        gst: product.gst || 0,
        image: product.pImage,
        isNew: true ,
        addOns: 1,
      }
    ]
  }));

            // setProductId(
            //   {
            //     name: product.title,
            //     id:  product._id,
            //   }
            // );
             setSearchQuery("");
          }

          

  useEffect(() => {

    getUserOrders();
 
  }, []);

  const hasDayLogic = (Order.items || []).some((item) => String(item.logic) === '1');
  const hasDistanceLogic = (Order.items || []).some((item) => String(item.logic) === '2');
  const showPerMinuteColumn = !hasDayLogic && !hasDistanceLogic;


  

const requestTest = async (e) => {
 const newItems = Order?.items
    ?.filter(item => item.isNew)
    .map(({ isNew, ...rest }) => rest);  // ✅ remove isNew

  const sendmsg = {
    userId: Order?.userId,
    type: "Request",
    items: newItems,
    orderId: Order?._id,
    id: Order.orderId,
    
  };

  sendMessage(sendmsg);
  console.log('sendmsg',sendmsg);
 
  // try{ 
  //   await toast.promise(
  //       axiosInstance.post(`/admin/add-order-item`, sendmsg),
  //       {
  //         loading: "Sending Request...", // Loading message
  //         success: "Sending Request successfully!", // Success message
  //         error: "Failed to Send Request", // Error message
  //       }
  //     );
 
  //     } catch (error) {
  //   console.error('Error fetching user products:', error);
  //       } 

};

function convertTo24Hour(timeStr) {
  if (!timeStr) return "";
  const [time, modifier] = timeStr.split(" ");
  let [hours, minutes] = time.split(":").map(Number);

  if (modifier === "PM" && hours < 12) hours += 12;
  if (modifier === "AM" && hours === 12) hours = 0;

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
}


function convertTo12Hour(timeStr) {
  if (!timeStr) return "";
  let [hours, minutes] = timeStr.split(":").map(Number);
  const modifier = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12; // convert 0 -> 12, 13 -> 1

  return `${hours}:${String(minutes).padStart(2, "0")} ${modifier}`;
}

function formatBookingDuration(value) {
  const hours = Number(value);
  if (!Number.isFinite(hours) || hours <= 0) return "NA";
  if (hours < 24) return `${hours} Hour${hours === 1 ? "" : "s"}`;

  const days = Math.floor(hours / 24);
  const remainingHours = hours % 24;
  return `${days} Day${days === 1 ? "" : "s"}${remainingHours ? ` ${remainingHours} Hour${remainingHours === 1 ? "" : "s"}` : ""}`;
}

const handleEndJob = () => {
  if (!navigator.geolocation) {
    toast.error("Geolocation is not supported by your browser");
    return;
  }
  navigator.geolocation.getCurrentPosition(
    (position) => {
      startJob("end", position.coords.latitude, position.coords.longitude);
    },
    (err) => {
      console.warn("Location error:", err);
      toast.error("Could not get location. Ending job without coordinates.");
      startJob("end"); // fallback: send without lat/lng
    }
  );
};

const startJob = async (time, lat = null, lng = null) => {

 
  const mydata = {
time,
OrderId : id,
otp: time === "start" ? "0000" : Order.otp,
    ...(lat !== null && lng !== null && { lat, lng }),

  }
  try{
    if(time === 'start'){
  await toast.promise(
        axiosInstance.post(`/admin/order/timer`, mydata),
        {
          loading: "Job starting...", // Loading message
          success: "Job started successfully!", // Success message
          error: "Failed to start job", // Error message
        }
      );
 
    } else{
        await toast.promise(
        axiosInstance.post(`/admin/order/timer`, mydata),
        {
          loading: "Job ending...", // Loading message
          success: "Job ending successfully!", // Success message
          error: "Failed to ending job", // Error message
        }
      );
 
    }
  
    setTimeout(function () {
  window.location.reload();
}, 1000); // 1000 milliseconds = 1 second


      } catch (error) {
      toast.error(error.response.data.message);
    console.error('Error start job:', error);
        }finally{
          getUserOrders();

        }
}

  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state

const UserUpdateData = async () => {
  setSubmitLoading(false);

  try {
    const pickupFullAddress =
      Order?.pickupFullAddress ?? Order?.items?.[0]?.pickupFullAddress ?? '';
    const updatedItems = (Order?.items || []).map((item, index) => (
      index === 0 ? { ...item, pickupFullAddress } : item
    ));
    const orderPayload = {
      ...Order,
      pickupFullAddress,
      items: updatedItems,
    };

    console.log("Sending updated Order data:", orderPayload);

    const response = await axiosInstance.put(`/admin/update-full-order/${id}`, orderPayload);

    if (response.data.success) {
      toast.success("Data updated successfully!");
    } else {
      toast.error("Update failed.");
    }
  } catch (error) {
    console.error("Error updating order:", error);
    toast.error("Error updating order");
  } finally {
    setSubmitLoading(true);
    getUserOrders(); // Refresh updated data
  }
};



  return (
    <>
      <Sidebar />
      <main class="content">
        <Navbar />

        <div className="pt-4 px-5">
          <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
            <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
              <li className="breadcrumb-item">
                <a href="#">
                  <svg
                    className="icon icon-xxs"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                    />
                  </svg>
                </a>
              </li>
              <li className="breadcrumb-item">
                <a href="#">Admin</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Ride ID #{Order.orderId}
              </li>
            </ol>
          </nav>
          <div className="d-flex justify-content-between w-100 flex-wrap">
          
          <div>
              {" "}
              <Link 
                to={`${(mydatatype === 1 && mydatatypeEmp === 2 ) ? '/all-jobs': '/all-order'}`}
                id="goBackButton"
                className="btn btn-primary d-inline-flex align-items-center"
              >
                <svg
                  style={{ transform: "rotate(180deg)" }}
                  className="icon icon-sm"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                Go back
              </Link>
            </div>


            <Link to={fronturl + 'account/order/'+ (Order?.userId || '') + '/' + (Order?._id || '') } className="btn btn-primary py-1">
              <i className="bi bi-download" />{" "}
              <span className="text">Invoice</span>
            </Link>

          </div>
        </div>

        <div id="main-content" className="bg-transparent ">

          {isLoading ? (
            <LoadingScreen/>
          ) :
            (<>


<div className='container mt-4 row mx-auto'>
{/* <button className='btn btn-danger ' onClick={()=>{startJob("end")}}>
  END JOB
</button> */}
<div className='col mb-3'>
  {!Order.startTime ? 
   <button className='btn btn-success text-white' type="button" onClick={() => { startJob("start") }}>
  START JOB 
</button>
  : !Order.endTime &&
   <button className='btn btn-danger '   data-bs-toggle="dropdown"
    aria-expanded="false" >
  END JOB
</button>
   }
   
  <ul className="dropdown-menu p-0">
   <div className="p-2 rounded bg-light   input-sm">
 {Order.startTime && !Order.endTime && (
 <button className="btn btn-primary dropdown-toggle btn-sm mt-3"
  // onClick={()=>{startJob("end")}}
  onClick={handleEndJob}
  >
                              End Job
                            </button>
 )}
                          </div>
  </ul>

</div>

 
<hr/>
  <div className="row g-3 mb-4">
    <div className="col-md-4">
      <div className="border rounded bg-white p-3 h-100">
        <div className="text-muted small fw-semibold text-uppercase">Order Created</div>
        <div className="fw-bold text-dark">{formatDateTime(Order.createdAt)}</div>
      </div>
    </div>
    <div className="col-md-4">
      <div className="border rounded bg-white p-3 h-100">
        <div className="text-muted small fw-semibold text-uppercase">Trip Start Date</div>
        <div className="fw-bold text-dark">{formatDateTime(Order.startTime)}</div>
      </div>
    </div>
    <div className="col-md-4">
      <div className="border rounded bg-white p-3 h-100">
        <div className="text-muted small fw-semibold text-uppercase">Trip End Date</div>
        <div className="fw-bold text-dark">{formatDateTime(Order.endTime)}</div>
      </div>
    </div>
  </div>
  <h4> Customer Details </h4>
   {/* Name input */}
   <div  className="form-outline col-md-12 mb-4">
                  <label className="form-label" htmlFor="form5Example1">
                    Full Name <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="text"
                    name="fullname"
                    id="form5Example1"
                    className="form-control"
                    value={Order?.details[0]?.username}
                    
                    style={{ boxShadow: "none" }}

                    onChange={(e) =>
    setOrder((prev) => ({
      ...prev,
      details: [
        {
          ...prev.details[0],
          username: e.target.value
        }
      ]
    }))
  }

                  />
                </div>
                {/* Email input */}
                <div  className="form-outline col-md-6 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Phone No. <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="number"
                    id="form5Example2"
                    className="form-control"
                    name="phone"
                    value={Order?.details[0]?.phone}
                    
                     onChange={(e) =>
    setOrder((prev) => ({
      ...prev,
      details: [
        {
          ...prev.details[0],
          phone: e.target.value
        }
      ]
    }))
  }

                    style={{ boxShadow: "none" }}
                  />
                </div>

                <div  className="form-outline col-md-6 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Email address{" "}
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="email"
                    id="form5Example2"
                    className="form-control"
                    name="email"
                    value={Order?.details[0]?.email}
                    
                    onChange={(e) =>
    setOrder((prev) => ({
      ...prev,
      details: [
        {
          ...prev.details[0],
          email: e.target.value
        }
      ]
    }))
  }

                    style={{ boxShadow: "none" }}
                  />
                </div>
				
				
  {/* <div  className="form-outline col-md-12 mb-4">
                  <label className="form-label" htmlFor="form5address">
                  Full Address
                    <span className="text-danger"> (Required )</span>
                  </label>
                  
                   <textarea
                    type="text"
                    id="address"
                    className="form-control"
                    name="address"
                    value={Order?.details[0]?.address}
                     onChange={(e) =>
    setOrder((prev) => ({
      ...prev,
      details: [
        {
          ...prev.details[0],
          address: e.target.value
        }
      ]
    }))
  }
                    style={{ boxShadow: "none" }}
                  />

                </div> */}
{/* 
                <div  className="form-outline col-md-12 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Pincode
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="text"
                    id="pincode"
                    className="form-control"
                    name="pincode"
                    value={Order?.details[0]?.pincode}
                    onChange={(e) =>
    setOrder((prev) => ({
      ...prev,
      details: [
        {
          ...prev.details[0],
          pincode: e.target.value
        }
      ]
    }))
  }
                    style={{ boxShadow: "none" }}
                  />
                </div> */}

<div className='col-12 '>
  <h4>Ride Details</h4>
  </div> 

 <div className="form-outline col-md-6 mb-4">
                  <label className="form-label" htmlFor="carType">
                  Car Type
                  </label>
                  <select
                    id="carType"
                    className="form-control"
                    name="carType"
                    value={Order.items?.[0]?.carType || ""}
                    style={{ boxShadow: "none" }}
                    onChange={(e) => handleItemChange(0, "carType", e.target.value)}
                    disabled={!Order.items?.[0]}
                  >
                    <option value="">Select car type</option>
                    {carTypeOptions.map((carType) => (
                      <option key={carType} value={carType}>
                        {carType}
                      </option>
                    ))}
                  </select>
                </div>


 <div  className="form-outline col-md-6 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                  Booking Date
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="date"
                    id="form5Example2"
                    className="form-control"
                    name="date"
                    value={Order.items?.[0]?.date || ''}
                    style={{ boxShadow: "none" }}

                    onChange={(e) => {
    const updatedItems = [...(Order.items || [])];
    updatedItems[0].date = e.target.value;
    setOrder((prev) => ({ ...prev, items: updatedItems }));
  }}
 


                  />
                </div>
 
                <div  className="form-outline col-md-6 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                     Booking Time
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="time"
                    id="form5Example2"
                    className="form-control"
                    name="time"
                    value={convertTo24Hour(Order.items?.[0]?.time)}
                    style={{ boxShadow: "none" }}
                     onChange={(e) => {
    const updatedItems = [...(Order.items || [])];
    updatedItems[0].time = e.target.value;
    setOrder((prev) => ({ ...prev, items: updatedItems }));
  }}
 
               
                  />
                </div>

                <div className="col-12">
                  <div className="card border-0 shadow-sm mb-4">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                        <div>
                          <h4 className="h6 mb-1">Pickup and Drop Location</h4>
                          <p className="small text-muted mb-0">Search with Google Maps. Latitude and longitude auto-fill from the selected place.</p>
                        </div>
                        <span className="badge bg-primary rounded-pill">Item location</span>
                      </div>

                      <div className="row g-3">
                        <div className="col-lg-6 position-relative">
                          <label className="form-label">Pickup Location</label>
                          <input
                            type="text"
                            className="form-control"
                            value={Order.items?.[0]?.pickup || Order.location || ''}
                            onChange={(e) => handleItemLocationChange(0, 'pickup', e.target.value)}
                            placeholder="Search pickup location"
                          />
                          {pickupSuggestions.length > 0 && (
                            <div className="list-group position-absolute w-100 shadow-sm" style={{ zIndex: 10 }}>
                              {pickupSuggestions.map((item) => (
                                <button
                                  key={item.place_id}
                                  type="button"
                                  className="list-group-item list-group-item-action"
                                  onClick={() => selectItemLocation(0, 'pickup', item)}
                                >
                                  {item.description}
                                </button>
                              ))}
                            </div>
                          )}
                          <div className="row g-2 mt-2">
                            <div className="col-sm-6">
                              <label className="form-label small text-muted mb-1">Pickup Lat</label>
                              <input
                                type="number"
                                step="any"
                                className="form-control form-control-sm"
                                value={Order.items?.[0]?.pickupMeta?.lat || Order.latitude || ''}
                                onChange={(e) => handleItemLocationMetaChange(0, 'pickup', 'lat', e.target.value)}
                                placeholder="Latitude"
                                disabled
                              />
                            </div>
                            <div className="col-sm-6">
                              <label className="form-label small text-muted mb-1">Pickup Lng</label>
                              <input
                                type="number"
                                step="any"
                                className="form-control form-control-sm"
                                value={Order.items?.[0]?.pickupMeta?.lng || Order.longitude || ''}
                                onChange={(e) => handleItemLocationMetaChange(0, 'pickup', 'lng', e.target.value)}
                                placeholder="Longitude"
                                disabled
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <label className="form-label">Additional Pickup Address</label>
                          <textarea
                            className="form-control"
                            rows="3"
                            value={Order.pickupFullAddress || Order.items?.[0]?.pickupFullAddress || ''}
                            onChange={(e) => handlePickupFullAddressChange(e.target.value)}
                            placeholder="Enter full pickup address"
                            disabled={!Order.items?.[0]}
                            style={{ resize: 'vertical' }}
                          />
                        </div>

                        <div className="col-lg-6 position-relative">
                          <label className="form-label">Drop Location</label>
                          <input
                            type="text"
                            className="form-control"
                            value={Order.items?.[0]?.dropoff || ''}
                            onChange={(e) => handleItemLocationChange(0, 'dropoff', e.target.value)}
                            placeholder="Search drop location"
                          />
                          {dropoffSuggestions.length > 0 && (
                            <div className="list-group position-absolute w-100 shadow-sm" style={{ zIndex: 10 }}>
                              {dropoffSuggestions.map((item) => (
                                <button
                                  key={item.place_id}
                                  type="button"
                                  className="list-group-item list-group-item-action"
                                  onClick={() => selectItemLocation(0, 'dropoff', item)}
                                >
                                  {item.description}
                                </button>
                              ))}
                            </div>
                          )}
                          <div className="row g-2 mt-2">
                            <div className="col-sm-6">
                              <label className="form-label small text-muted mb-1">Drop Lat</label>
                              <input
                                type="number"
                                step="any"
                                className="form-control form-control-sm"
                                value={Order.items?.[0]?.dropoffMeta?.lat || ''}
                                onChange={(e) => handleItemLocationMetaChange(0, 'dropoff', 'lat', e.target.value)}
                                placeholder="Latitude"
                                disabled
                              />
                            </div>
                            <div className="col-sm-6">
                              <label className="form-label small text-muted mb-1">Drop Lng</label>
                              <input
                                type="number"
                                step="any"
                                className="form-control form-control-sm"
                                value={Order.items?.[0]?.dropoffMeta?.lng || ''}
                                onChange={(e) => handleItemLocationMetaChange(0, 'dropoff', 'lng', e.target.value)}
                                placeholder="Longitude"
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

{/* 
<div className='col-md-12 bg-white border p-3 mb-3 rounded '>
  {ProductId && ProductId.name && 
    <p className='bg-warning px-2 text-white w-auto d-inline-block mb-2 rounded'> Filter Product :   {ProductId.name} </p>
  } 
      
                <div
                  className={`input-group d-flex me-5 w-500 searchbox flex-fill ${!showSearch && "search-view"
                    } `}
                  style={{ backgroundColor: "#f3f7fb" }}
                >
                  <input
                    id="searchInput"
                    className="form-control searchinput"
                    type="text"
                    placeholder="Search for products,category and more"
                    value={searchQuery}
                    onChange={handleInputChange}
                  />
                  <button
                    type="button"
                    className="btn btn-primary bg-gradient d-none d-lg-block search  text-secondary"
                  >
                    <i className="ri-search-line fw-bold" />
                  </button>

           
                  {searchQuery && (
                    <>
                      <button
                        type="button"
                        className="btn btn-primary bg-gradient d-none d-lg-block close"
                        onClick={handleClearClick}
                      >
                        {" "}
                        <i class="navbar-actions-icon ri-close-line fs-7"></i>{" "}
                      </button>
                    </>
                  )}
                </div>

                {searchQuery && (
                    <>
                      <ul class="searchfloat mt-3 p-0">
                        {searchQuery &&
                          filteredProducts &&
                          filteredProducts.map((item) => {
                            console.log("item.slug", item.slug);
                            const myslug =  item._id;  
                            return (
                              <li key={item.id} className='d-block'>
                                <Link 
                                  onClick={()=> handleClickProduct(item)}
                                > 
                                  <i class="ri-shopping-bag-line"></i>{" "}
                                  {item.title} {(item.stock || item.stock === 0 )&& <> |  <span class="badge bg-warning font-small px-2 py-1 text-white-800 ms-1 fw-bold"> {item.stock} available</span> </>} <span> </span>
                                </Link>
                              </li>
                            );
                          })}
                      
                      </ul>
                    </>
                  )} 

</div> */}


<div className='overflow-auto d-none'>


                            <table style={{ borderCollapse: "collapse", width: "100%" }}>
                              <tbody>
                                <tr style={{ background: '#00406e', color: "white" }} >
                                  <td style={{ padding: 10, fontWeight: "bold" }}>Items</td>
                                  <td style={{ padding: 10, fontWeight: "bold" }}>QTY</td>
                                  <td style={{ padding: 10, fontWeight: "bold" }}> Price </td>

  
                               
                                    <td style={{ padding: 10, fontWeight: "bold" }}>GST	</td>
                                   
                                  

                                  <td style={{ padding: 10, fontWeight: "bold" }}>Total </td>

                                  {/* <td  style={{ padding: 10, fontWeight: "bold" }} >Action </td> */}
                                </tr>


                                {Order.items.map((Pro,index) => (
                                  <tr key={index} >
                                    <td style={{ padding: 10, maxWidth: '200px', borderWidth: '1px', borderColor: '#a2a2a2' }}>
                                   {Pro.isNew ? (
        <input
          type="text"
          value={Pro.title}
          onChange={(e) => handleItemChange(index, 'title', e.target.value)}
          className="form-control shadow-none"
        />
      ) : (
        <div className="d-flex mb-2">
                                        <div className="flex-shrink-0">
                                          <img
                                            src={Pro.image}
                                            alt=""
                                            width={35}
                                            className="img-fluid"
                                          />
                                        </div>
                                        <div className="flex-lg-grow-1 ms-3">
                                          <h6 className="small mb-0">
                                            
                                            <Link href={`/product/${Pro.id}`} className="text-reset">
                                              {Pro.title}
                                            </Link>
                                          </h6>

                                        </div>
                                      </div>
      )}
       
                                    </td>
                                 
                                    <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }} >
                                     {Pro.isNew ? (
        <input
          type="number"
          value={Pro.quantity}
          onChange={(e) => handleItemChange(index, 'quantity', e.target.value)}
          className="form-control shadow-none"
        />
      ) : (
        Pro.quantity
      )}
          
                                       </td>

                                    <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }}  >
                                      
                                      {Pro.isNew ? (
        <input
          type="number"
          value={Pro.price ?? 0}
          onChange={(e) => handleItemChange(index, 'price', e.target.value)}
          className="form-control"
        />
      ) : (
        `₹${Math.round(Pro.price - (((Pro.price * Pro.gst) / 100))).toFixed(0)}`
      )}
      
       </td>

  
                 <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }}> 
                   {Pro.isNew ? (
        <input
          type="number"
          value={Pro.gst}
          onChange={(e) => handleItemChange(index, 'gst', e.target.value)}
          className="form-control"
        />
      ) : (
        `${Pro.gst}%`
      )}
     </td>


                                  
                                    <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }} > ₹{Pro.quantity * Pro.price} </td>

{/* <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }}  >
 {index === Order.items.length - 1 && (
        <button className="btn btn-primary btn-sm" onClick={handleAddRow}>
          Add
        </button>
      )}
       </td> */}
 </tr>
                                ))}


                              </tbody>
                              <tfoot>
                                {/* <tr>
                                  <td  style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }} >
Total
                                  </td>
                                  <td  style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }} >
                                  {Order.items.reduce((total, item) => total + item.quantity , 0)} 
                                  </td>

                          

                                  <td  style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }} >
₹{Math.round(Order.items.reduce((total, item) => total + item.price - (((item.price * item.gst) / 100)), 0)).toFixed(0)}
                                  </td>
        

                                
                              
                                  
                                  {Order.primary === 'true' ? (<>
                                      <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }} >  ₹{Math.round(Order.items.reduce((total, item) => total + (((item.price * item.gst) / 100)/2), 0)).toFixed(0)}  </td>
                                      <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }} >  
                                      ₹{Math.round(Order.items.reduce((total, item) => total + (((item.price * item.gst) / 100)/2), 0)).toFixed(0)}
                                       </td>

                                  </>):(<>
                                    <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }} >  ₹{Math.round(Order.items.reduce((total, item) => total + (((item.price * item.gst) / 100)), 0)).toFixed(0)}  </td>
                                    </>) }

                                  
                                  <td  style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }} >
                                  ₹{Order.items.reduce((total, item) => total + item.quantity * item.price , 0)}
                                  </td>


                                </tr> */}
                                
                                <tr className="d-none">
                                <td colSpan="3"></td>
                                  <td colSpan={1} style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }} > Subtotal </td>
                                  <td className="text-end" style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }} >₹{Order.items.reduce((total, item) => total + item.quantity * item.price, 0)}</td>
                                </tr>




                                {false && (<tr>
                                <td colSpan="3"></td>


                                  <td colSpan={1} style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }}  >  Shipping</td>
                                  <td className="text-end" style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }}  >₹{Order.shipping}</td>
                                </tr>)}
                                <tr>
                                <td colSpan="3"></td>

                                  <td colSpan={1} style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }}  > Discount </td>

                                  <td className="text-danger text-end" style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }} >
                                    <div className="input-group input-group-sm justify-content-end">
                                      <span className="input-group-text text-danger">- Rs</span>
                                      <input
                                        type="number"
                                        min="0"
                                        value={Order.discount ?? 0}
                                        onChange={(e) => handleDiscountChange(e.target.value)}
                                        className="form-control text-end text-danger"
                                        style={{ maxWidth: 140 }}
                                      />
                                    </div>
                                  </td>

                                  <td className="text-danger text-end" style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }} > {Order.items.reduce((total, item) => total + item.quantity * item.price, 0) - Math.abs(Order.discount) === 0 ? '₹0' : (
                                    <>- ₹{Math.abs(Order.discount)}
                                    </>
                                  )}  </td>
                                </tr>
                                <tr className="fw-bold">
                                <td colSpan="3"></td>

                                  <td colSpan={1} style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }}  > TOTAL</td>
                                  <td className="text-end" style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }}>₹{Order.totalAmount}</td>
                                </tr>
                              </tfoot>


                            </table>
  
</div>


{Order.startTime && Order.endTime && (() => {
  const start = new Date(Order.startTime);
  const end = new Date(Order.endTime);

  const diffMs = end - start; // Difference in milliseconds
  const totalSeconds = Math.floor(diffMs / 1000);

  const days = Math.floor(totalSeconds / (3600 * 24));
  const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const parts = [];
  if (days) parts.push(`${days} day${days !== 1 ? 's' : ''}`);
  if (hours) parts.push(`${hours} hour${hours !== 1 ? 's' : ''}`);
  if (minutes) parts.push(`${minutes} minute${minutes !== 1 ? 's' : ''}`);
  if (seconds || parts.length === 0) parts.push(`${seconds} second${seconds !== 1 ? 's' : ''}`);

  return (
    <div className="alert alert-success fw-bold" role="alert">
      <span className='text-dark'> Working HR: </span> {parts.join(', ')}
    </div>
  );
})()}


<div className='overflow-auto'>
    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                              <tbody>
                                <tr style={{ background: '#00406e', color: "white" }} >
                                   <td style={{ padding: 10, fontWeight: "bold" }}>Items</td>
                                   <td style={{ padding: 10, fontWeight: "bold" }}> Price </td>
                                   {showPerMinuteColumn && (
                                     <td style={{ padding: 10, fontWeight: "bold" }}> Per minute price </td>
                                   )}
                                   {hasDayLogic && (
                                     <td style={{ padding: 10, fontWeight: "bold" }}> Full Day </td>
                                   )}
                                   {hasDistanceLogic && (
                                     <td style={{ padding: 10, fontWeight: "bold" }}> Per km price </td>
                                   )}
                                   <td style={{ padding: 10, fontWeight: "bold" }}> Logic </td>

  
                                  {/* {Order.primary === 'true' ? (<>
                                    <td style={{ padding: 10, fontWeight: "bold" }}>CGST</td>
                                  <td style={{ padding: 10, fontWeight: "bold" }}>SGST</td>
                                  </>):(<>
                                    <td style={{ padding: 10, fontWeight: "bold" }}>IGST	</td>
                                    </>) }
                                   */}

                                  <td style={{ padding: 10, fontWeight: "bold" }}>Total </td>

                                  
                                </tr>


                                {Order.items.map((Pro,index) => (
                                  <tr key={index}>
                                    <td style={{ padding: 10, maxWidth: '300px',minWidth:300, borderWidth: '1px', borderColor: '#a2a2a2' }} className='text-nowrap'>
                                {Pro.isNew ? (
        <input
          type="text"
          value={Pro.title}
          onChange={(e) => handleItemChange(index, 'title', e.target.value)}
          className="form-control shadow-none"
        />
                                    ) : (  
                                       <div className="d-flex mb-2 text-nowrap">
                                        <div className="flex-shrink-0 text-nowrap">
                                          <img
                                            src={Pro.image}
                                            alt=""
                                            width={35}
                                            className="img-fluid"
                                          />
                                        </div>
                                        <div className="flex-lg-grow-1 ms-3 text-nowrap">
                                          <h6 className="small mb-0 text-nowrap">
                                            <Link href={`/product/${Pro.id}`} className="text-reset text-nowrap">
                                              {Pro.title}
                                            </Link>
                                            <p className='text-dark small'>
                                        
                                                 <div className="fs-sm"> 
                              <span className="text-body-secondary">Date: </span>
                              <span className="text-body-secondary">  {Pro?.date ? new Date(Pro.date).toLocaleDateString('en-US', {
      weekday: 'short',
      day: '2-digit',
      month: 'short'
    }) : 'NA'} </span>
                            </div>

                             <div className="fs-sm"> 
                              <span className="text-body-secondary">Time: </span>
                              <span className="text-body-secondary">{Pro?.time || 'NA'} / {formatBookingDuration(Pro.hour)}</span>
                            </div>



                          

                                            </p>
                                          </h6>

                                        </div>
                                      </div> ) }

                                         <div className="fs-sm small"> 
                              <b className=" fw-bold text-black">Pickup: </b>
                              <span className="text-body-secondary" style={{whiteSpace:'break-spaces'}}> {Pro?.pickup ?? "NA"} </span>
                              <a target="_blank" href={`https://www.google.com/maps/search/?api=1&query=${Pro?.pickup ?? "NA"}`} className='bg-success text-white px-2 py-1 rounded-pill'>
                                 View on map <i className="ri-map-2-fill"></i>
                                 </a>
                            </div>
<hr/>
  <div className="fs-sm small"> 
                              <b className=" fw-bold text-black">Drop: </b>
                              <span className="text-body-secondary" style={{whiteSpace:'break-spaces'}} > {Pro?.dropoff} </span>
                               <a target="_blank" href={`https://www.google.com/maps/search/?api=1&query=${Pro?.dropoff ?? "NA"}`} className='bg-success text-white px-2 py-1 rounded-pill'>
                                 View on map <i className="ri-map-2-fill"></i>
                                 </a>
                            </div>

                                    </td>
                                 
 <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }}  >
                                    {true ? (
        <input
          type="number"
          value={Pro.price}
          onChange={(e) => handleItemChange(index, 'price', e.target.value)}
          className="form-control"
        />
      ) : ( <> ₹{Math.round(Pro.price).toFixed(0)} </> )} </td> 

  
 {showPerMinuteColumn && (
 <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }}  >
        <input
          type="number"
          value={Pro.minPrice ?? 0}
          onChange={(e) => handleItemChange(index, 'minPrice', e.target.value)}
          className="form-control"
        />
       </td>
 )}

 {hasDayLogic && (
 <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }}  >
      {String(Pro.logic) === '1' && (
        <input
          type="number"
          value={Pro.fullday ?? Pro.day ?? 0}
          onChange={(e) => handleItemChange(index, 'fullday', e.target.value)}
          className="form-control"
        />
      )}
       </td>
 )}

 {hasDistanceLogic && (
 <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }}  >
      {String(Pro.logic) === '2' && (
        <input
          type="number"
          value={Pro.kmCharges ?? 0}
          onChange={(e) => handleItemChange(index, 'kmCharges', e.target.value)}
          className="form-control"
        />
      )}
       </td>
 )}

 <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }}  >
        <select
          value={Pro.logic ?? 0}
          onChange={(e) => handleItemChange(index, 'logic', e.target.value)}
          className="form-control"
        >
          <option value="0">NO Logic</option>
          <option value="1">Day Logic</option>
          <option value="2">Distance Logic</option>
        </select>
       </td> 

                                    {/* {Order.primary === 'true' ? (<>
                                      <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }} > ₹{(Pro.GSTPrice - Pro.price)/2}	 </td>
                                      <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }} >  ₹{(Pro.GSTPrice - Pro.price)/2} </td>
                                 
                                  </>):(<>
                                    <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }}> ₹{(Pro.GSTPrice - Pro.price)}	</td>
                                    </>) } */}

                                  
                                    <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }} > ₹{Pro.quantity * Pro.price} </td>

 </tr>
                                ))}


                              </tbody>
                              <tfoot >
                                {/* <tr>
                                  <td  style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }} >
Total
                                  </td>
                              
                          

                          
        
                                  <td  style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }} >
                                  ₹{Order.items.reduce((total, item) => total + item.regularPrice - item.price , 0)}
                                  </td>

                                  
                                  {Order.primary === 'true' ? (<>
                                      <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }} >  ₹{Math.round(Order.items.reduce((total, item) => total + (((item.GSTPrice * item.gst) / 100)/2), 0)).toFixed(0)}  </td>
                                      <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }} >  
                                      ₹{Math.round(Order.items.reduce((total, item) => total + (((item.price * item.gst) / 100)/2), 0)).toFixed(0)}
                                       </td>

                                  </>):(<>
                                    <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }} >  ₹{Math.round(Order.items.reduce((total, item) => total + (((item.GSTPrice * item.gst) / 100)), 0)).toFixed(0)}  </td>
                                    </>) }

                                  
                                  <td  style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }} >
                                  ₹{Order.items.reduce((total, item) => total + item.quantity * item.GSTPrice , 0)}
                                  </td>


                                </tr> */}
                                <tr>
                                  <td colSpan={10} >
<br/>
                                  </td>
                                </tr>
                                <tr className="d-none">
                                <td colSpan={Order.primary === 'true' ? 1 : 0}></td>
                                  <td colSpan={1} style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }} > Subtotal </td>
                                  <td className="text-end" style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }} >₹{Order.items.reduce((total, item) => total + item.quantity * item.price, 0)}</td>
                                </tr>




                                {false && (<tr>
                                <td colSpan={Order.primary === 'true' ? 1 : 0}></td>


                                  <td colSpan={1} style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }}  >  Shipping</td>
                                  <td className="text-end" style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }}  >₹{Order.shipping}</td>
                                </tr>)}

{false && (Order.items?.[0]?.NightCharges ?? 0) !== 0 && 

   <tr>
                                <td colSpan={Order.primary === 'true' ? 1 : 0}></td>

                                  <td colSpan={1} style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }}  > Night Charges </td>

                                  <td className="text-dark text-end" style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }} > 
                                  ₹  {Order.items?.[0]?.NightCharges ?? 0}
                             </td>
                                </tr>

}
                                 
                             

                                <tr>
                                <td colSpan={Order.primary === 'true' ? 1 : 0}></td>

                                  <td colSpan={1} style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }}  > Discount </td>

                                  <td className="text-danger text-end" style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }} >
                                    <div className="input-group input-group-sm justify-content-end">
                                      <span className="input-group-text text-danger">- Rs</span>
                                      <input
                                        type="number"
                                        min="0"
                                        value={Order.discount ?? 0}
                                        onChange={(e) => handleDiscountChange(e.target.value)}
                                        className="form-control text-end text-danger"
                                        style={{ maxWidth: 140 }}
                                      />
                                    </div>
                                  </td>

                                  <td className="text-danger text-end d-none" style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }} > {Order.items.reduce((total, item) => total + item.quantity * item.price, 0) - Math.abs(Order.discount) === 0 ? '₹0' : (
                                    <>- ₹{Math.abs(Order.discount)}
                                    </>
                                  )}  </td>
                                </tr>
                                {[
                                  ["bookingCharges", "Booking Charges"],
                                  ["nightCharges", "Night Charges"],
                                  ["mealCharges", "Meal Charges"],
                                  ["conveyanceCharges", "Conveyance Charges"],
                                ].map(([field, label]) => (
                                  <tr key={field}>
                                    <td colSpan={Order.primary === 'true' ? 1 : 0}></td>
                                    <td colSpan={1} style={{
                                      padding: ".75rem",
                                      verticalAlign: "top",
                                      borderWidth: '1px', borderColor: '#a2a2a2'
                                    }}  > {label} </td>
                                    <td className="text-end" style={{
                                      padding: ".75rem",
                                      verticalAlign: "top",
                                      borderWidth: '1px', borderColor: '#a2a2a2'
                                    }} >
                                      <div className="input-group input-group-sm justify-content-end">
                                        <span className="input-group-text">Rs</span>
                                        <input
                                          type="number"
                                          min="0"
                                          value={getOrderChargeValue(Order, field)}
                                          onChange={(e) => handleChargeChange(field, e.target.value)}
                                          className="form-control text-end"
                                          style={{ maxWidth: 140 }}
                                        />
                                           {field === "nightCharges" && (
          <span className="ms-2 text-nowrap">
            × {Order.nightDays || 0} Day{Order.nightDays > 1 ? "s" : ""}
            <span className="ms-2 text-muted">
              = ₹{formatOrderAmount(calculateNightChargeTotal(Order))}
            </span>
          </span>
        )}
                                      </div>
                                    </td>
                                  </tr>
                                ))}


                                <tr>
                                <td colSpan={Order.primary === 'true' ? 1 : 0}></td>

                                  <td colSpan={1} style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }}  >
                                    Platform Charges 
                                    {/* <div className="small text-muted">
                                     Platform charges 
                                      {toNumber(Order.driverCommissionPercent) ? ` (${Order.driverCommissionPercent}%)` : ""}
                                    </div> */}
                                  </td>
                                  <td className="text-end" style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }}>₹{formatOrderAmount(calculateOrderTaxAmount(Order))}</td>
                                </tr>


                                <tr className="fw-bold">
                                <td colSpan={Order.primary === 'true' ? 1 : 0}></td>

                                  <td colSpan={1} style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }}  > TOTAL</td>
                                  <td className="text-end" style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }}>  ₹{formatOrderAmount(Order.totalAmount)}</td>
                                </tr>
                              </tfoot>


                            </table>
</div>
              

 
{/* <div className='d-flex align-items-center justify-content-end gap-2 mt-2'>
<button className="btn btn-secondary btn-sm" type='button' onClick={getUserOrders} > <i className="ri-restart-line"/> Refresh</button>
<button className="btn btn-success text-white btn-sm" onClick={requestTest}>  Send
   <i className="ri-send-plane-2-fill"/> </button>
</div>   */}

  {/* <div  className="form-outline col-md-12 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Comment{" "}
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <textarea
                    type="text"
                    id="comment"
                    className="form-control"
                    name="comment"
                    value={Order.comment}
                    
                    style={{ boxShadow: "none" }}
                  />
                 
                </div>  
				 */}
				
 
 
   
                  {!Order.endTime && <div className="col-12 mb-3">
                    {SubmitLoading ? (
                      <button
                        className="btn btn-secondary"
                        type="button"
                        onClick={UserUpdateData}
                      >
                       Update Data
                      </button>
                    ) : (
                      <button
                        class="btn btn-secondary btn-sm"
                        type="button"
                        disabled
                      >
                        <span class="ms-1">Loading...</span>
                        <span
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      </button>
                    )}
                  </div>}


</div>





            </>)}





        </div>


      </main>
    </>
  )
}

export default FullOrderView
